/**
 * This workspace opens in Nursing.
 *
 * The workspace default program is the first one in the list (Medicine), and
 * Exam Management is not licensed for it, so a first visit used to sit on
 * "Choose a program". This is a nursing program, so on the very first boot we
 * do what the campus picker does when someone presses a program: record Nursing
 * for the school. After that the person is in charge: switching to Physical
 * Therapy sticks, and this never runs again.
 */

import { getStorageItem, setStorageItem } from "@exxatdesignux/ui/lib/persisted-state"

import { stampSchoolFamilyScope } from "@/hooks/use-active-scope"
import { NAV_SCHOOLS } from "@/lib/mock/navigation"

const SEEDED = "opening-program:v1"

export function seedOpeningProgram(): void {
  try {
    if (getStorageItem(SEEDED)) return
    const school = NAV_SCHOOLS[0]
    const nursing = school?.programs.find((program) => program.id === "son")
    if (school && nursing) stampSchoolFamilyScope(school, nursing)
    setStorageItem(SEEDED, "1")
  } catch {
    // Storage can be unavailable; the program picker still works.
  }
}
